import Container from 'portal/Container';
import CtaButton from '@opploans/cta-button-component/CtaButton';
import PhoneNumber from '@opploans/phone-number-component/PhoneNumber';
import React from 'react';

const headerStyle = {
  fontSize: '1.5rem',
  textAlign: 'center'
};

function AccountLockedContents() {
  return (
    <Container noBackground>
      <h1 css={headerStyle}>Account Locked</h1>
      <p>
        Due to too many incorrect SSN attempts your account has been locked.
      </p>
      <p>
        Please call us at <PhoneNumber isLink /> to speak to an agent to resolve
        this issue.
      </p>
      <CtaButton
        id='logout'
        onClick={() => {
          window.location.href = '/auth/logout';
        }}
      >
        Sign Out
      </CtaButton>
    </Container>
  );
}

export default AccountLockedContents;
